import { SearchPayload } from '@creator/sdk/modules/search';

export function getSearchHashByPayload(seachType: 'posts' | 'comments' | 'users' | 'tokens', searchPayload: SearchPayload): string {
    const { text, range, filterBy = [], sortField } = searchPayload;

    const _filterBy = filterBy.map(filter => `${filter.field}_${filter.value}`);
    return `${seachType}-${text.replaceAll(' ', '_')}-${range}-${_filterBy}-${sortField}`;
}